import styled from 'styled-components';

import { mediaQueryMobileLargeMin } from '@/styleUtils';

import { StaticContentSection } from '../StaticContent.styles';

export const Wrapper = styled(StaticContentSection)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media ${mediaQueryMobileLargeMin} {
    gap: 24px;
  }
`;
export const Step = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
`;
export const Image = styled.img`
  width: 56px;
  flex-shrink: 0;
`;
export default Wrapper;
